import { render, staticRenderFns } from "./thumb.global.vue?vue&type=template&id=01ee90c7&"
import script from "./thumb.global.vue?vue&type=script&lang=js&"
export * from "./thumb.global.vue?vue&type=script&lang=js&"
import style0 from "./thumb.global.vue?vue&type=style&index=0&id=01ee90c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports